var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrapper", attrs: { id: "app" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "main_mess" }, [
        _c("p", { staticClass: "nav_cha" }, [_vm._v("联系人信息")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", { staticClass: "mess_li" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("姓名：")]),
            _vm._v(" "),
            _c("div", { staticClass: "filediv" }, [
              _vm._v(_vm._s(_vm.fullName))
            ])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "mess_li" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("性别：")]),
            _vm._v(" "),
            _c("div", { staticClass: "filediv" }, [_vm._v(_vm._s(_vm.sexName))])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "mess_li" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("生日：")]),
            _vm._v(" "),
            _c("div", { staticClass: "filediv" }, [
              _vm._v(_vm._s(_vm.birthday))
            ])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "mess_li" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("手机号码：")]),
            _vm._v(" "),
            _c("div", { staticClass: "filediv" }, [
              _vm._v(_vm._s(_vm.telPhone))
            ])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "mess_li" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("邮箱：")]),
            _vm._v(" "),
            _c("div", { staticClass: "filediv" }, [_vm._v(_vm._s(_vm.email))])
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "nav_cha" }, [_vm._v("机构信息")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", { staticClass: "mess_li" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("机构名称：")]),
            _vm._v(" "),
            _c("div", { staticClass: "filediv" }, [
              _vm._v(_vm._s(_vm.userName))
            ])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "mess_li" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("机构简称：")]),
            _vm._v(" "),
            _c("div", { staticClass: "filediv" }, [
              _vm._v(_vm._s(_vm.shortName))
            ])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "mess_li" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("机构网址：")]),
            _vm._v(" "),
            _c("div", { staticClass: "filediv" }, [_vm._v(_vm._s(_vm.website))])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "mess_li set-imgHeight" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("证件上传：")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "fileimg",
              attrs: { src: _vm.bizLicenseImg }
            })
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "mess_li" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("负责人姓名：")]),
            _vm._v(" "),
            _c("div", { staticClass: "filediv" }, [
              _vm._v(_vm._s(_vm.principalName))
            ])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "mess_li" }, [
            _c("span", { staticClass: "fileing" }, [_vm._v("手机号码：")]),
            _vm._v(" "),
            _c("div", { staticClass: "filediv" }, [
              _vm._v(_vm._s(_vm.principalPhone))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogTableVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [_c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("详情")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ddc8a52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ddc8a52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/orgmgr/orgmgrwcDetails.vue
// module id = null
// module chunks = 